import { Button, Container, FloatingLabel, Form, InputGroup, Modal, Row } from "react-bootstrap";
import { PolicyDto } from "../../model/PolicyDto";
import { Column, DateTimePicker, Icon, Label, Panel, Select } from "../../../components";
import * as labelconstant from '../../../shared/util/label';
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../shared/store";
import { useContext, useEffect, useState } from "react";
import { SelectOption } from "../../../shared/components/input";
import { CommonUtility } from "../../../Services/CommonUtility";
import DatePicker from "react-datepicker";
import LookupService from "../../../Services/LookupService";
import * as constant from '../../../shared/util/constant';
import { PolicyEventDto } from "../../model/PolicyEventDto";
import { PolicyTransactionPremiumDto } from "../../model/PolicyTransactionPremiumDto";
import CustomerPolicyActionService from "./CustomerPolicyActionService";
import { updateLookupData } from "../../customer-slice/Customer-lookup-slice";
import { PolicyTransactionsReadDto } from "../../model/PolicyTransactionsReadDto";
import { useHistory } from "react-router-dom";
import { setCustomerSummary, storeCustomerPolicies, updateCustomers, updateSelectedPolicyDetails } from "../../customer-slice/Customer-slice";
import { toast } from "react-toastify";
import { ConfirmModal } from "../../../shared/components/confirmModal";
import './Customer-Policy-Action.scss';
import Logger from "../../../shared/services/Logger";
import CustomerPolicyListService from "../CustomerPolicyListService";

export interface ICustomerPolicyActionDelete {
    policyId: string;
    selectedAction: string;
    onCloseModal: () => void;
}
const CustomerPolicyDelete: React.FunctionComponent<ICustomerPolicyActionDelete> = (props) => {
       const {policyId, selectedAction, onCloseModal } = props;
       const dispatch = useDispatch();
       const [activityDescription, setActivityDescription] = useState<string>('');    
       const [formValidation, setFormValidation] = useState<any>({});  
        const [addActivity, setAddActivity] = useState<boolean>(false);
        const policyActionService = new CustomerPolicyActionService();
     
    const handleSavePolicy = async () => {
        try {
            let validationErrors: any = {};
            if (addActivity && (!activityDescription || activityDescription.trim().length === 0)) {
                validationErrors['description'] = {isValid : false, warningText :  constant.FIELD_CANNOT_BE_BLANK}
            }
            setFormValidation(validationErrors);
            if (Object.keys(validationErrors).length > 0) {
                return;
            }
            let response = await policyActionService.deletePolicy(activityDescription, policyId, addActivity);
            const customerPolicyListService = new CustomerPolicyListService();
            try {
                const updatedPolicies = await customerPolicyListService.fetchCustomerPolicyDetails(response.policy.custId);
                dispatch(storeCustomerPolicies(updatedPolicies || []));
            } catch (error) {
                const status = error?.response?.status || error?.status;
                if (status === 404) {
                    dispatch(storeCustomerPolicies([]));
                } else {
                    toast.error(labelconstant.PolicyActionLabels.ERROR_MESSAGE, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    return;
                }
            }
            toast.success(labelconstant.PolicyActionLabels.DELETE_POLICY_SUCCESS_MESSAGE, {
                position: toast.POSITION.TOP_RIGHT
            });
            onCloseModal();
            } catch (error) {
                const status = error?.response?.status || error?.status;
                const errorMessage = error?.data?.error || error?.statusText || '';
                if (errorMessage === "PENDING_TASKS_EXIST_FOR_POLICY") {
                    toast.error(labelconstant.PolicyActionLabels.DELETE_POLICY_PENDING_TASKS_MESSAGE, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    onCloseModal();
                    return;
                }
                if (status === 404) {
                    dispatch(storeCustomerPolicies([]));
                    toast.success(labelconstant.PolicyActionLabels.DELETE_POLICY_SUCCESS_MESSAGE, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    onCloseModal();
                    return;
                } else {
                    toast.error(labelconstant.PolicyActionLabels.ERROR_MESSAGE, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    return;
                }
            }
    };

     const onEntityFieldChange = (propName: string, value: string | Date | boolean) => {   
      if(propName === "description")
        {
            setActivityDescription(value.toString());
        }
      }
       
    return (
        <>
            <Container fluid className="mt-4">
                <Row style={{ display: 'flex' }}>
                    <Row>
                        <Column>
                            {labelconstant.PolicyActionLabels.DELETE_POLICY_CONFIRM_MESSAGE}
                        </Column>
                    </Row>
                    <Row className="mt-4">
                        <Column>
                            <Form.Check
                                id="addActivityForDelete"
                                label={'Add Activity'}
                                checked={addActivity}
                                onChange={e => setAddActivity(e.target.checked)}
                                className="mb-3 custom-checkbox"
                            />
                        </Column>
                    </Row>
                    {addActivity && (
                        <Row className="mt-2">
                            <Column>
                                <FloatingLabel
                                    controlId="descriptionTxt"
                                    label={
                                        <>
                                            {labelconstant.PolicyActionLabels.DESCRIPTION}
                                            <span className="text-danger">*</span>
                                        </>
                                    }
                                >
                                    <Form.Control
                                        type="text"
                                        name="description"
                                        placeholder={labelconstant.PolicyActionLabels.DESCRIPTION}
                                        value={activityDescription || ""}
                                        onChange={(event) => onEntityFieldChange('description', event.currentTarget.value)}
                                        disabled={false}
                                        maxLength={300}
                                        width={200}
                                        required={true}
                                        isInvalid={formValidation['description']?.isValid == false}
                                        tabIndex={1}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formValidation['description']?.warningText}
                                    </Form.Control.Feedback>
                                </FloatingLabel>
                            </Column>
                        </Row>
                    )}
                    <Row className="mt-4 justify-content-end">
                        <Column lg={2} className="d-flex justify-content-end">
                            <button
                                className="btn btn-primary me-2"
                                onClick={() => onCloseModal()}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={() => handleSavePolicy()}
                            >
                                Delete
                            </button>
                        </Column>
                    </Row>
                </Row>
            </Container>
        </>
    );
};
export default CustomerPolicyDelete;
